export default "__VITE_ASSET__d281ac06__"